export default function() {
  const widgetName = 'cardWidgetVideos';
  const widgetOpts = cardWidgetVideosOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      let ytScriptLoaded = false;
      const items = data.items;

      $(`#${widgetName} .buttonwrap a`).addClass('button');
      $('<span class="cw-titleborder"></span>').insertAfter(`#${widgetName} .card-widget-title`);
      $(`#${widgetName} .card-widget-item`).each(function(i) {
        const $this = $(this);
        const videoID = items[i].DetailLinkText;
        $this.attr('data-index', i);
        $this.prepend(`
          <div class="image-container" data-videoid="${videoID}">
            <img data-src="https://img.youtube.com/vi/${videoID}/hqdefault.jpg" class="lozad">
          </div>
        `);
      });

      $(`#${widgetName} .image-container`).on('click', function() {
        const $this = $(this);
        const playerNum = $this.parent().attr('data-index');
        const vidID = $this.attr('data-videoid');
        $this.addClass('video-active');

        function createYTPlayer () {
          $this.html(`<div id="ytPlayer${playerNum}"></div>`);
          let player;

          function onYouTubeIframeAPIReady() {
            player = new window.YT.Player(`ytPlayer${playerNum}`, {
              height: '208',
              width: '370',
              videoId: vidID,
              playerVars: {
                'playsinline': 1,
                'iv_load_policy': 3,
                'modestbranding': true,
                'rel': 0
              },
              events: {
                'onReady': onPlayerReady
              }
            });
            function onPlayerReady(event) {
              event.target.playVideo();
            }
          }
          onYouTubeIframeAPIReady()
        }
        
        if (!ytScriptLoaded) {
          $.getScript('https://www.youtube.com/iframe_api', function() {
            createYTPlayer()
            ytScriptLoaded = true;
          });
        } else {
          createYTPlayer();
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 3,
    moreButton: {
      visible: true,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev','Next'],
      nav: true
    },
    textOverImage: false
  });

}